import {FormattedMessage} from 'react-intl';
import React, {useEffect, useRef, useState} from 'react';
import LoadingSkeleton from '../../cmp/LoadingSkeleton';

export default function Statistic({value, id, cls, loading}) {
    const ref = useRef();
    const [shouldShow, setShouldShow] = useState(true)
    useEffect(() => {
        if(ref.current){
            if(window.getComputedStyle(ref.current).display === "none"){
                setShouldShow(false)
            }
        }
    }, [ref.current]);
    if(!shouldShow) return null;
    return (<div className={`card ${cls || ''}`} ref={ref}>
        <div className={'card-body'}>
            {
                loading ? <>
                <LoadingSkeleton height={44}/>
                </> : <h2>{value}</h2>
            }
            <small className={'text-muted'}><FormattedMessage id={id}/></small>
        </div>
    </div>);
}
